const calculatePriceWithDiscount = (
  originalPrice: number,
  discount: number
): number => {
  return originalPrice * (1 - discount);
};

export default calculatePriceWithDiscount;
